import CustomerType from "./actionTypes"

const OtherCustomerAction = {
  getListPage: data => ({
    type: CustomerType.GET_OTHER_CUSTOMER_PAGES,
    payload: data,
  }),
  getListPageSuccess: data => ({
    type: CustomerType.GET_OTHER_CUSTOMER_PAGES_SUCCESS,
    payload: data,
  }),

  getDetail: (data, action) => ({
    type: CustomerType.GET_DETAIL_OTHER_CUSTOMER_BY_ID,
    payload: data,
    action
  }),
  getDetailSuccess: data => ({
    type: CustomerType.GET_DETAIL_OTHER_CUSTOMER_BY_ID_SUCCESS,
    payload: data,
  }),

  getListHistoryPage: data => ({
    type: CustomerType.GET_OTHER_CUSTOMER_HISTORIES_PAGES,
    payload: data,
  }),
  getListHistoryPageSuccess: data => ({
    type: CustomerType.GET_OTHER_CUSTOMER_HISTORIES_PAGES_SUCCESS,
    payload: data,
  }),
  postData: (data, action) => ({
    type: CustomerType.POST_OTHER_CUSTOMER,
    payload: data,
    action
  }),
  postDataSuccess: data => ({
    type: CustomerType.POST_OTHER_CUSTOMER_SUCCESS,
    payload: data,
  }),

  putData: (data, action) => ({
    type: CustomerType.PUT_OTHER_CUSTOMER,
    payload: data,
    action
  }),
  putDataSuccess: data => ({
    type: CustomerType.PUT_OTHER_CUSTOMER_SUCCESS,
    payload: data,
  })
}


const IgarashiCustomerAction = {
  getListPage: data => ({
    type: CustomerType.GET_IGARASHI_CUSTOMER_PAGES,
    payload: data,
  }),
  getListPageSuccess: (data) => ({
    type: CustomerType.GET_IGARASHI_CUSTOMER_PAGES_SUCCESS,
    payload: data,
  }),

  getDetail: (data, action) => ({
    type: CustomerType.GET_DETAIL_IGARASHI_CUSTOMER_BY_ID,
    payload: data,
    action
  }),
  getDetailSuccess: data => ({
    type: CustomerType.GET_DETAIL_IGARASHI_CUSTOMER_BY_ID_SUCCESS,
    payload: data,
  }),
  getListHistoryPage: data => ({
    type: CustomerType.GET_IGARASHI_CUSTOMER_HISTORIES_PAGES,
    payload: data,
  }),
  getListHistoryPageSuccess: (data) => ({
    type: CustomerType.GET_IGARASHI_CUSTOMER_HISTORIES_PAGES_SUCCESS,
    payload: data,
  }),
  postData: (data, action) => ({
    type: CustomerType.POST_IGARASHI_CUSTOMER,
    payload: data,
    action
  }),
  postDataSuccess: data => ({
    type: CustomerType.POST_IGARASHI_CUSTOMER_SUCCESS,
    payload: data,
  }),

  putData: (data, action) => ({
    type: CustomerType.PUT_IGARASHI_CUSTOMER,
    payload: data,
    action
  }),
  putDataSuccess: data => ({
    type: CustomerType.PUT_IGARASHI_CUSTOMER_SUCCESS,
    payload: data,
  })
}

export {
  OtherCustomerAction,
  IgarashiCustomerAction
}





